import EzOption from './EzOption.vue';

export { EzOption };

export { default } from './EzSelect.vue';
